import React from 'react';
import Withdraw from ".";
import authRoles from "../../utils/auth.roles";
import WithdrawDetail from "./WithdrawDetail";
import WithdrawStatus from "./WithdrawStatus";
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";

const withNotificationBlock = (Component) => {
  const WrappedComponent = (props) => {
    const notification = useSelector(({ Auth }) => Auth.notification);
    const location = useLocation();
    if (notification?.isEnabled) {
      return <Navigate to="/home" state={{ from: location }} replace />;
    }
    return <Component {...props} />;
  };
  WrappedComponent.displayName = `WithNotificationBlock(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

const WithdrawDefaultRedirect = () => <Navigate to="/withdraw/0" />;

const GuardedRedirect = withNotificationBlock(WithdrawDefaultRedirect);
const GuardedWithdraw = withNotificationBlock(Withdraw);
const WithdrawRoutes = {
  auth: authRoles.user,
  kyc: false,
  routes: [
    {
      path: "/withdraw",
      component: GuardedRedirect,
      exact: true,
    },
    {
      path: "/withdraw/:screen",
      component: GuardedWithdraw,
      exact: true,
    },
    {
      path: "/withdraw/:screen/:type",
      component: GuardedWithdraw,
      exact: true,
    },
    {
      path: "/withdraw/:screen/:type/:extra",
      component: GuardedWithdraw,
      exact: true,
    },
    {
      path: "/withdraw/status",
      component: WithdrawStatus,
      exact: true
    },
    {
      path: "/withdraw/status/:id",
      component: WithdrawStatus,
      exact: true
    },
    {
      path: "/withdraw/details/:id",
      component: WithdrawDetail,
      exact: true
    }
  ],
};
export default WithdrawRoutes;
